export class Counter {
  private element: HTMLElement;
  private start: number;
  private end: number;
  private duration: number;
  private increment: number;
  private step: number;
  private interval: any;

  constructor(element: HTMLElement, start: number, end: number, duration: number) {
    this.element = element;
    this.start = start;
    this.end = end;
    this.duration = duration;
    this.increment = this.calculateIncrement(end - start);
    this.step = Math.abs(Math.floor(duration / ((end - start) / this.increment)));
  }

  calculateIncrement(range: number): number {
    if (range <= 100) return 1;
    if (range <= 1000) return 10;
    if (range <= 10000) return 100;
    return 1000; // Adjust as needed
  }

  startCounting() {
    let current = this.start;
    this.element.textContent = current.toString().padStart(this.end.toString().length, ' '); 
    this.interval = setInterval(() => {
      current += this.increment;
      this.element.textContent = current.toString();
      if (current >= this.end) {
        clearInterval(this.interval);
        this.element.textContent = this.end.toString(); 
      }
    }, this.step);
  }

  startCountingWhenVisible() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startCounting();
          observer.unobserve(this.element);
        }
      });
    });

    observer.observe(this.element);
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  const elements = document.querySelectorAll('.agence-chiffre__number');
  elements.forEach((element, index) => {
    const end = parseInt(element.textContent || '0');
    const counter = new Counter(element as HTMLElement, 0, end, 3000); 
    counter.startCountingWhenVisible();
  });
});
  
export const agenceCounter = new Counter(document.getElementById('count1') as HTMLElement, 0, 100, 3000);